import React from 'react'
import {useIntl} from 'react-intl'

import OptionChips from '../../../chat/OptionChips'

const DATE_RANGE_CHIPS = ['Last 30 days', 'Last week', 'This month', 'Today']

type AttendanceV2NeedsInputViewProps = {
  fields: string[]
  theme: 'light' | 'dark'
  onChipSelect: (value: string) => void
}

const AttendanceV2NeedsInputView: React.FC<AttendanceV2NeedsInputViewProps> = ({
  fields,
  theme,
  onChipSelect,
}) => {
  const intl = useIntl()
  const chips: string[] = []
  if (fields.includes('dateRange')) {
    chips.push(...DATE_RANGE_CHIPS)
  }

  const mutedColor = theme === 'dark' ? 'rgba(255,255,255,0.75)' : '#6c757d'

  return (
    <div className='mt-2'>
      {chips.length > 0 ? (
        <OptionChips options={chips} onSelect={onChipSelect} theme={theme} layout='vertical' />
      ) : null}
      {fields.includes('dateRange') ? (
        <div className='mt-2' style={{fontSize: '0.8rem', color: mutedColor}}>
          {intl.formatMessage({id: 'CHATBOT.ATTENDANCE.NEEDS_INPUT_DATE_TYPE_HINT'})}
        </div>
      ) : null}
      {fields.includes('className') ? (
        <div className='mt-2' style={{fontSize: '0.8rem', color: mutedColor}}>
          {intl.formatMessage({id: 'CHATBOT.ATTENDANCE.NEEDS_INPUT_CLASS_TYPE_HINT'})}
        </div>
      ) : null}
    </div>
  )
}

export default AttendanceV2NeedsInputView
